<template>
  <v-container fluid fill-height>
    <v-layout align-center justify-center>
      <v-flex xs12 sm8 md4>
        <v-card class="elevation-12">
          <v-toolbar dark color="primary">
            <v-toolbar-title>Login to Southview Student Directory</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-btn elevation="7" outlined raised text large block @click="gotoNewStudent()" color="primary">NEW STUDENTS CLICK HERE</v-btn>
            <v-divider></v-divider>
            <br/>
            <h3>Login</h3>
            <v-form >
              <v-text-field v-model="username" prepend-icon="person" name="login" label="Email" type="text"></v-text-field>
              <v-text-field @keyup.enter="login()" v-model="password"  id="password" prepend-icon="lock" name="password" label="Password" type="password"></v-text-field>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn text @click="gotoSignup()" color="primary">Sign-up</v-btn>
            <v-btn text @click="gotoForgotPassword()" color="primary">Forgot password?</v-btn>
            <v-spacer></v-spacer>
            <v-btn @click="login()" color="primary">Login</v-btn>
          </v-card-actions>
          <v-snackbar
            v-model="snackbar"
            :color="snackbarType"
            :timeout="snackbarTimeout"
            top
          >
            {{ snackbarMessage }}
            <v-btn dark text @click="snackbar = false">
              Close
            </v-btn>
          </v-snackbar>
        </v-card>            
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import firebase from 'firebase';
export default {
  name: 'Login',
  data () {
    return {
      username:'',
      password:'',
      snackbar:false,
      snackbarMessage:'',
      snackbarType:'error',
      snackbarTimeout: 10000
    }
  },
  methods: {
    login() {
      firebase.auth().signInWithEmailAndPassword(this.username, this.password).then((user)=> {
        console.log('Logged in: ', user);
        this.$router.replace('/students');

      }).catch((error) => {
        console.error('Login error: ', error);
        this.snackbarTimeout = 0;
        this.snackbarMessage = error.message;
        this.snackbarType = 'error';
        this.snackbar = true;
      });
    },
    gotoSignup() {
      this.$router.push('/signup');
    },
    gotoForgotPassword() {
      this.$router.push('/forgot-password');
    },
    gotoNewStudent() {
      this.$router.push('/new-student');
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
